var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('v-fade-transition',[_c(Component,{tag:"component"})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }